import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG } from '@boma/app-config';
import { IPaginatedResponse } from '@boma/client-shared';
import {
  IVarianceCreateRequest,
  IVarianceRequest,
  IVarianceResponse,
} from '@boma/supplier-portal/shared/entities';
import { HelperFunctionsService } from '../helper-functions/helper-functions.service';

@Injectable({
  providedIn: 'root',
})
export class VariancesService {
  private readonly base: string;
  private readonly version: string;

  constructor(
    @Inject(APP_CONFIG) private configuration: any,
    private http: HttpClient,
    private helperService: HelperFunctionsService
  ) {
    this.base = configuration.apiRoute;
    this.version = configuration.apiVersion;
  }

  listVariances(
    entityId: string,
    requestBody: IVarianceRequest = {},
    page = 1,
    perPage = 25
  ) {
    const queryParams = [`page=${page}`, `pageSize=${perPage}`];
    const urlQuery = `?${queryParams.join('&')}`;
    return this.http.post<IPaginatedResponse<IVarianceResponse>>(
      `${this.base}api/v${this.version}/${entityId}/Variances/List/${urlQuery}`,
      requestBody
    );
  }

  createVariance(entityId: string, requestBody: IVarianceCreateRequest) {
    return this.http.post<IPaginatedResponse<IVarianceResponse>>(
      `${this.base}api/v${this.version}/${entityId}/Variances`,
      requestBody
    );
  }
}
